export class PosterLocationInput {
    longitude: number;
    latitude: number;
    isNew: boolean;
   constructor() {
       this.isNew = false;
   }
}
